/* eslint-disable */

/**
 * A collection of helper functions that are used by the frontend handler.
 */
const helpers = {

	/**
	 * Converts an RGBA value to its corresponding hex representation.
	 *
	 * @param {string} color
	 *
	 * @return {string}
	 */
	rgb2hex( color ) {
		const rgba = color.replace( /^rgba?\(|\s+|\)$/g, '' ).split( ',' );

		const hex = `#${ ( ( 1 << 24 ) + ( parseInt( rgba[ 0 ] ) << 16 ) + ( parseInt( rgba[ 1 ] ) << 8 ) + parseInt( rgba[ 2 ] ) ).toString( 16 ).slice( 1 ) }`;

		return hex;
	},
	/**
	 * Gets field values.
	 *
	 * @param  field
	 * @return {string}
	 */
	getBillingAddressMergeTag( field ) {
		if ( field === '' ) {
			return '';
		}
		return '{:' + field + ':value}';
	},

	/**
	 * Checks if we are on last page.
	 *
	 * @return {boolean}
	 */
	isLastPage() {
		const targetPageInput = jQuery( '#gform_target_page_number_' + this.formId );
		if ( targetPageInput.length > 0 ) {
			return targetPageInput.val() == 0;
		}

		return true;
	},

	/**
	 * Checks if current page has the Square credit card field on it.
	 *
	 * @param  ccPage
	 * @return {boolean}
	 */
	isCreditCardOnPage( ccPage ) {
		const currentPage = this.getCurrentPageNumber();

		// if current page is false or no credit card page number, assume this is not a multi-page form.
		if ( ! ccPage || ! currentPage ) {
			return true;
		}

		return ccPage == currentPage;
	},

	/**
	 * Gets current page number.
	 *
	 * @return {*}
	 */
	getCurrentPageNumber() {
		const currentPageInput = jQuery( '#gform_source_page_number_' + this.formId );
		return currentPageInput.length > 0 ? currentPageInput.val() : false;
	},

	/**
	 * Checks if a spinner should be added next to the submit button and adds one if needed.
	 *
	 * @param  isAjax
	 * @param  formId
	 */
	maybeAddSpinner( isAjax, formId ) {
		if ( isAjax ) {
			return;
		}

		if ( typeof gformAddSpinner === 'function' ) {
			gformAddSpinner( formId );
		} else if ( jQuery( '#gform_ajax_spinner_' + formId ).length == 0 ) {
			const spinnerUrl = gform.applyFilters( 'gform_spinner_url', gf_global.spinnerUrl, formId ),
				$spinnerTarget = gform.applyFilters( 'gform_spinner_target_elem', jQuery( '#gform_submit_button_' + formId + ', #gform_wrapper_' + formId + ' .gform_next_button, #gform_send_resume_link_button_' + formId ), formId );
			$spinnerTarget.after( '<img id="gform_ajax_spinner_' + formId + '"  class="gform_ajax_spinner" src="' + spinnerUrl + '" alt="" />' );
		}
	},

	/**
	 * Removes Square Card hidden inputs
	 *
	 * @param  form   form object
	 * @param  formId
	 */
	resetSquareStatus( form, formId ) {
		// Remove appended inputs.
		jQuery( '#' + formId + '_square_nonce, #' + formId + '_square_credit_card_last_four, #' + formId + '_square_credit_card_type, #' + formId + '_square_verification' ).remove();
	},

	/**
	 * Resets form status when errors are received after trying to submit.
	 *
	 * @param  form       form object
	 * @param  formId
	 * @param  isLastPage
	 */
	resetFormStatus( form, formId ) {
		// Reset form status.
		form.data( 'gfsquaresubmitting', false );
		// Remove spinner.
		jQuery( '#gform_ajax_spinner_' + formId ).remove();
		// must do this or the form cannot be submitted again.
		if ( this.isLastPage( formId ) ) {
			window[ 'gf_submitting_' + formId ] = false;
		}
	},

	/**
	 * Clears any displayed errors.
	 *
	 * @param  formId
	 * @param  fieldId
	 */
	clearErrors( formId, fieldId ) {
		const creditCardDetailContainer = jQuery( '#input_' + formId + '_' + fieldId + '_1' );
		const cardHolderNameContainer = jQuery( '#input_' + formId + '_' + fieldId + '_3' );

		if ( creditCardDetailContainer.next( '.validation_message' ).length ) {
			creditCardDetailContainer.next( '.validation_message' ).html( '' );
		}

		if ( cardHolderNameContainer.next( '.validation_message' ).length ) {
			cardHolderNameContainer.next( '.validation_message' ).html( '' );
		}
	},

	/**
	 * Calculates the form total if needed.
	 *
	 * @param  formId
	 * @param  activeFeed
	 */
	updatePaymentAmount( formId, activeFeed ) {
		if ( activeFeed.paymentAmount !== 'form_total' ) {
			let price = GFMergeTag.getMergeTagValue( formId, activeFeed.paymentAmount, ':price' ),
				qty = GFMergeTag.getMergeTagValue( formId, activeFeed.paymentAmount, ':qty' );

			if ( typeof price === 'string' ) {
				price = GFMergeTag.getMergeTagValue( formId, activeFeed.paymentAmount + '.2', ':price' );
				qty = GFMergeTag.getMergeTagValue( formId, activeFeed.paymentAmount + '.3', ':qty' );
			}

			window[ 'gform_square_amount_' + formId ] = price * qty;
		} else if ( activeFeed.paymentAmount === 'form_total' ) {
			gformCalculateTotalPrice( formId );
		}
	},
};

export default helpers;
